import "./JsonObjs.css"

import { useState, useEffect, useRef } from "react";
import { RcdList } from "../../input_types/Tbl/Tbl";
import { useRcdEditDialog, useObjEditDialog } from "../../input_types/Dialog/Dialog.jsx";

export default function JsonObjs({fldName, form, fldDef, opts}){
    opts = opts || {};
    const {onChange, ...rest} = form.register(fldName, {required: 1})

    const refData = useRef({
        init: false,
        curRcdIdx: 0
    });

    //  one or more rcds
    const getVal = _=>JSON.parse(form.getValues()[fldName]||'[]');
    const [val, setVal] = useState(getVal());
    const [del, setDel] = useState([]);

    const {
        // dialog interface
        formId,
        isDialogOpen,
        setIsDialogOpen,
        openDialog,

        closeDialog,
        handleConfirm,
        handleOK,

        setTblDef,
        setRcd,

        // compo,ent
        Dialog
    } = useObjEditDialog({
        tblDef: fldDef.objTpl||{},
        rcd:val,
        btns: [
            ({closeDialog, key})=><button
                key={key}
                className='btn btn-warning' 
                onClick={evt=>closeDialog()}>Cancel</button>,
            ({closeDialog, formId, dlgData, key})=><button
                key={key}
                form={formId}
                // type="submit"
                type="button"
                onClick={evt=>{
                    console.log('dlgData:', dlgData);
                    const mainRcd =  dlgData.forms.mainForm.form.getValues();
                    const rcd = {...mainRcd};
                    delete rcd.__id;
                    if(mainRcd.__id){
                        const idx = mainRcd.__id;
                        val[idx-1] = rcd;
                    }else{
                        val.push(rcd)
                    }
                    form.setValue(fldName, JSON.stringify(val));
                    setTimeout(_=>closeDialog(), 100);
                }}
            >OK</button>
        ]
    });


    // console.log('getVal:', fldName, val);

    return <div
        className="border rounded" 
    >
        <Dialog></Dialog>
        <RcdList
            tblDef={fldDef.objTpl}
            rcds={{
                rcds: (val=>{
                    if(!val)return [];
                    if(val.constructor!=Array)return [val];
                    return val;
                })(val),
                rcdCnt: val.length
            }}
            opts={{
                btns: {
                    edit: ({rcdId, rcdIdx})=><button type="button"
                        className="btn btn-primary"
                        onClick={evt=>{
                            // evt.stopPropagation();
                            // setTblName(tblName);
                            refData.current.curRcdIdx = rcdIdx;
                            setRcd({...val[rcdIdx], __id:rcdIdx+1});
                            openDialog();
                        }}
                    >edit</button>,
                    del: ({rcdId, rcdIdx})=><button type="button"
                        className="btn btn-primary"
                        onClick={evt=>{
                            refData.current.curRcdIdx = rcdIdx;
                            // openDialog();
                            delete val[rcdIdx];
                            const newVal = val.filter(a=>a);
                            form.setValue(fldName, JSON.stringify(newVal));
                            setVal(newVal);
                        }}
                    >del</button>,
                },
                listBtns:{
                    add: ({rcdId})=><button type="button"
                        className="btn btn-primary"
                        onClick={evt=>{
                            // evt.stopPropagation();
                            // setTblName(tblName);
                            refData.current.curRcdIdx = null;
                            setRcd({});
                            openDialog();
                        }}
                    >add</button>
                }
            }}
        ></RcdList>
    </div>;
}